module.exports = {
    myHost: { 
       'host':'https://api-bnps.smicee.com',

    }
};
